import { Component, OnInit, Input, Inject } from '@angular/core';
import { NeedHelpService } from '../../api/services/need-help.service';
import { APP_CONFIG } from '../../api/config';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { WindowRef } from '../../common';

@Component({
  selector: 'live-chat',
  templateUrl: './live-chat.component.html',
  styleUrls: ['./live-chat.component.scss'],
  providers: [NeedHelpService]
})
export class LiveChatComponent implements OnInit {
  @Input() messages;

  appConfig: IAppConfig;
  brandCode: string;
  liveChatUrl: string;
  isSupported: boolean;

  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig, private _window: WindowRef, private needHelpService: NeedHelpService) {
    this.appConfig = appConfig;
  }

  ngOnInit() {
    this.brandCode = this.appConfig.brand.brandCode;
    this.liveChatUrl = '/hotels/' + this.appConfig.country + '/' + this.appConfig.language + '/reservation/searchresult/chatFrameSet?brandcode=' + this.brandCode;
    this.isSupported = this.needHelpService.isLiveChatSupported();
  }

  openLiveChat() {
    if (this.needHelpService.popupChat && !this.needHelpService.popupChat.closed) {
      this.needHelpService.popupChat.focus();
    } else {
      this.needHelpService.popupChat = this._window.nativeWindow.open(this.liveChatUrl, '', 'status=0,scrollbars=no,resizable=0,height=550,width=650,left=100,top=50');
    }
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/live-chat/live-chat.component.ts